import {
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import _ from 'lodash';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Proofreading } from 'src/app/models/proofreading.model';
import { MemberStatus } from 'src/app/models/projects/submodels/members.model';
import { MembersProofreadingModal } from '../members-proofreading-modal/members-proofreading-modal.component';
import { MembersService } from 'src/app/services/member.service';
import { ProofreadingMember, IProofreadingMember } from 'src/app/models/proofreading-member.model';


@Component({
    selector: 'app-members-assessments',
    templateUrl: './members-assessments.component.html',
    styleUrls: ['./members-assessments.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MembersAssessmentsComponent {

    @Input() readonly: boolean = false;
    @Input() proofreading?: Proofreading;

    protected _members: ProofreadingMember[];
    @Input() set members(value: IProofreadingMember[]) {
        console.log('ASSESSMENTS', value);
        this._members = value.map(m => new ProofreadingMember(m));
    };
    get members(): ProofreadingMember[] {
        return this._members || this.proofreading?.members || this.s_members.members || [];
    }

    get main_member(): IProofreadingMember | undefined {
        return this.members.find(member => member.hasApproDocument);
    }

    get current_approval_number(): number {
        return this.members?.filter(member => member.status === MemberStatus.ACCEPT || member.status === MemberStatus.REJECT).length || 0;
    }

    get total_approval_number(): number {
        return this.members?.filter(member => member.hasApproDocument || member.hasApproInfo).length || 0;
    }

    get hasPreemptiveRefusal() {
        return this.members.filter(m => m.hasPreemptiveRight && m.status === MemberStatus.REJECT).length;
    }

    constructor(
        protected dialog: MatDialog,
        protected s_members: MembersService
    ) { }

    openMembersModel(): void {
        this.dialog.open(MembersProofreadingModal, {
            width: '80rem',
            data: {
                readonly: this.readonly,
                members: this._members,
            },
        });
    }
}

